export default __webpack_public_path__ + "static/media/Age-Of-Defi.b3fb5581.png";